/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_TitleInputs */

const en_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Center`)
};

const fr_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position : Au Centre`)
};

const de_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Mitte`)
};

const it_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione: Centro`)
};

const ru_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Центр`)
};

const es_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición: Centro`)
};

const zh_cn2_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：中路`)
};

const ja_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポジション: センター`)
};

const hi_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान: केंद्र`)
};

const pt_pt2_position_center_title = /** @type {(inputs: Position_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Centro`)
};

/**
* | output |
* | --- |
* | "Position: Center" |
*
* @param {Position_Center_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_title = /** @type {((inputs?: Position_Center_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_center_title(inputs)
	if (locale === "de") return de_position_center_title(inputs)
	if (locale === "it") return it_position_center_title(inputs)
	if (locale === "ru") return ru_position_center_title(inputs)
	if (locale === "es") return es_position_center_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_center_title(inputs)
	if (locale === "ja") return ja_position_center_title(inputs)
	if (locale === "hi") return hi_position_center_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_center_title(inputs)
	return en_position_center_title(inputs)
});